import { z } from "zod";
import {
  SubmissionSchema,
  SubmitterTemplateSchema,
} from "../../models/document.schema";

export const SendSignRequestResultSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("needs_review"),
    submitters: SubmitterTemplateSchema.array(),
    missingEmailSubmitterUuids: z.string().array(),
  }),
  z.object({
    status: z.literal("sent"),
    submitters: SubmitterTemplateSchema.array(),
    submissionId: z.number().int(),
    submission: SubmissionSchema,
  }),
]);

export const PrivateSignRequestControllerResponseSchema = {
  createSignRequestTemplate: z.object({
    templateId: z.number().int(),
    slug: z.string(),
  }),

  getSignRequestEditToken: z.object({
    editToken: z.string(),
  }),

  sendSignRequest: SendSignRequestResultSchema,

  onSignRequestSend: z.void(),

  onSignRequestCancel: z.void(),

  resendSignRequests: z.void(),

  resendSignRequest: z.void(),

  setSignRequestExpirationDate: z.void(),

  deleteSignRequestTemplate: z.void(),

  stopSubmission: z.void(),

  updateSubmitters: z.boolean(),
};
